import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const ScrollableTableContainer = styled.div`
  font-family: 'Circular-Std-Bold';
  max-height: 500px;
  height: 500px;
  overflow-y: auto;
  padding-right: 15px;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.softGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.placeholder}; // barra
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.strongBlack};
  }
  
  & > div {
    font-family: Circular-Std;
  }
`

export const DataHead = styled.div`
  font-size: 20px;
  gap: 8px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  padding: 2px;
`
export const DataRow = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.strongGray};
  text-align: left;
`

export const Button = styled.button`
  padding: 4px 8px;
  font-size: 12px;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  background-color: ${colors.grayButtonBackground};
`

export const Container = styled.div`
  height: 400px;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
`

export const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: ${colors.placeholder};
  margin-top: 24px;
`
export const Subtitle = styled.div`
  font-size: 20px;
  font-weight: 520;
  color: ${colors.placeholder};
  margin-top: 8px;
`

export const Icon = styled.span`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: ${colors.softGray};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`
